module.exports = __webpack_public_path__ + "assets/img/driver-btn-95fde4fc.png";